import { RefObject, useEffect } from 'react';

interface UseScrollToTopOptions {
  behavior?: ScrollBehavior;
  smooth?: boolean;
}

/**
 * Hook that scrolls to the top of a ref when a dependency changes
 * @param ref - The ref to scroll
 * @param dependency - The dependency that triggers the scroll
 * @param options - Optional scroll behavior options
 */
export const useScrollToTop = <T extends HTMLElement>(
  ref: RefObject<T>,
  dependency: unknown,
  options: UseScrollToTopOptions = {}
) => {
  const { behavior = 'smooth', smooth = true } = options;

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({
        top: 0,
        behavior: smooth ? behavior : 'auto',
      });
    }
  }, [dependency, ref, behavior, smooth]);
};
